import { isObject } from 'lodash';
import type { ApiDriver } from '~/api/types';
import type { DriversByClientState } from './types';

export const isValidDriverData = (data: unknown): data is ApiDriver => {
    return isObject(data);
};

export const isValidPayloadData = (data: unknown, clientId: string) => {
    const isValidData = isValidDriverData(data);
    return isValidData && data.client === clientId;
};

export const getAllDriversFromState = (state: DriversByClientState) => {
    return Object.values(state).flatMap((item) => item);
};
